/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { models_CreateOrderRequest } from '../models/models_CreateOrderRequest';
import type { models_DenyOrderRequest } from '../models/models_DenyOrderRequest';
import type { models_MarkPaidRequest } from '../models/models_MarkPaidRequest';
import type { models_OrderActionResponse } from '../models/models_OrderActionResponse';
import type { models_OrderAuditTrailResponse } from '../models/models_OrderAuditTrailResponse';
import type { models_OrderResponse } from '../models/models_OrderResponse';
import type { models_OrdersListResponse } from '../models/models_OrdersListResponse';
import type { models_UpdateOrderRequest } from '../models/models_UpdateOrderRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OrdersService {
    /**
     * List orders
     * Returns a list of orders for the specified event
     * @param organizer Organizer slug
     * @param event Event slug
     * @param page Page number for pagination
     * @param ordering Ordering field
     * @param code Filter by order code
     * @param status Filter by order status
     * @param search Search term
     * @param customer Filter by customer
     * @param item Filter by item ID
     * @param variation Filter by variation ID
     * @param testmode Filter by test mode
     * @param requireApproval Filter by approval requirement
     * @param email Filter by email
     * @param locale Filter by locale
     * @param modifiedSince Filter by modification date
     * @param createdSince Filter by creation date
     * @param createdBefore Filter by creation date
     * @param salesChannel Filter by sales channel
     * @returns models_OrdersListResponse OK
     * @throws ApiError
     */
    public static getOrganizersEventsOrders(
        organizer: string,
        event: string,
        page?: number,
        ordering?: string,
        code?: string,
        status?: string,
        search?: string,
        customer?: string,
        item?: number,
        variation?: number,
        testmode?: boolean,
        requireApproval?: boolean,
        email?: string,
        locale?: string,
        modifiedSince?: string,
        createdSince?: string,
        createdBefore?: string,
        salesChannel?: string,
    ): CancelablePromise<models_OrdersListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/events/{event}/orders',
            path: {
                'organizer': organizer,
                'event': event,
            },
            query: {
                'page': page,
                'ordering': ordering,
                'code': code,
                'status': status,
                'search': search,
                'customer': customer,
                'item': item,
                'variation': variation,
                'testmode': testmode,
                'require_approval': requireApproval,
                'email': email,
                'locale': locale,
                'modified_since': modifiedSince,
                'created_since': createdSince,
                'created_before': createdBefore,
                'sales_channel': salesChannel,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Create order
     * Creates a new order with optional question answers for each position
     * @param organizer Organizer slug
     * @param event Event slug
     * @param body Order data with positions and answers
     * @returns models_OrderResponse Order created successfully with answers
     * @throws ApiError
     */
    public static postOrganizersEventsOrders(
        organizer: string,
        event: string,
        body: models_CreateOrderRequest,
    ): CancelablePromise<models_OrderResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/events/{event}/orders',
            path: {
                'organizer': organizer,
                'event': event,
            },
            body: body,
            errors: {
                400: `Invalid request or validation failed`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get order by code
     * Returns details of a specific order
     * @param organizer Organizer slug
     * @param event Event slug
     * @param code Order code
     * @returns models_OrderResponse OK
     * @throws ApiError
     */
    public static getOrganizersEventsOrders1(
        organizer: string,
        event: string,
        code: string,
    ): CancelablePromise<models_OrderResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/events/{event}/orders/{code}',
            path: {
                'organizer': organizer,
                'event': event,
                'code': code,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Update order
     * Updates an existing order
     * @param organizer Organizer slug
     * @param event Event slug
     * @param code Order code
     * @param body Order data
     * @returns models_OrderResponse OK
     * @throws ApiError
     */
    public static putOrganizersEventsOrders(
        organizer: string,
        event: string,
        code: string,
        body: models_UpdateOrderRequest,
    ): CancelablePromise<models_OrderResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/organizers/{organizer}/events/{event}/orders/{code}',
            path: {
                'organizer': organizer,
                'event': event,
                'code': code,
            },
            body: body,
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Cancel order
     * Cancels an existing order
     * @param organizer Organizer slug
     * @param event Event slug
     * @param code Order code
     * @returns models_OrderActionResponse OK
     * @throws ApiError
     */
    public static deleteOrganizersEventsOrders(
        organizer: string,
        event: string,
        code: string,
    ): CancelablePromise<models_OrderActionResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/organizers/{organizer}/events/{event}/orders/{code}',
            path: {
                'organizer': organizer,
                'event': event,
                'code': code,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Approve order
     * Approves an order that requires approval (deprecated, use mark_paid)
     * @param organizer Organizer slug
     * @param event Event slug
     * @param code Order code
     * @returns models_OrderActionResponse OK
     * @throws ApiError
     */
    public static postOrganizersEventsOrdersApprove(
        organizer: string,
        event: string,
        code: string,
    ): CancelablePromise<models_OrderActionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/events/{event}/orders/{code}/approve',
            path: {
                'organizer': organizer,
                'event': event,
                'code': code,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Get order audit trail
     * Returns the audit log trail for a specific order
     * @param organizer Organizer slug
     * @param event Event slug
     * @param code Order code
     * @param limit Maximum number of entries to return (default 50, max 100)
     * @returns models_OrderAuditTrailResponse OK
     * @throws ApiError
     */
    public static getOrganizersEventsOrdersAuditTrail(
        organizer: string,
        event: string,
        code: string,
        limit?: number,
    ): CancelablePromise<models_OrderAuditTrailResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/events/{event}/orders/{code}/audit-trail',
            path: {
                'organizer': organizer,
                'event': event,
                'code': code,
            },
            query: {
                'limit': limit,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Deny order
     * Denies an order that requires approval
     * @param organizer Organizer slug
     * @param event Event slug
     * @param code Order code
     * @param body Denial data
     * @returns models_OrderActionResponse OK
     * @throws ApiError
     */
    public static postOrganizersEventsOrdersDeny(
        organizer: string,
        event: string,
        code: string,
        body: models_DenyOrderRequest,
    ): CancelablePromise<models_OrderActionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/events/{event}/orders/{code}/deny',
            path: {
                'organizer': organizer,
                'event': event,
                'code': code,
            },
            body: body,
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Mark order as paid
     * Marks an order as paid (manual payment confirmation)
     * @param organizer Organizer slug
     * @param event Event slug
     * @param code Order code
     * @param body Mark paid options
     * @returns models_OrderResponse OK
     * @throws ApiError
     */
    public static postOrganizersEventsOrdersMarkPaid(
        organizer: string,
        event: string,
        code: string,
        body?: models_MarkPaidRequest,
    ): CancelablePromise<models_OrderResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/events/{event}/orders/{code}/mark_paid',
            path: {
                'organizer': organizer,
                'event': event,
                'code': code,
            },
            body: body,
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
